<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: 'TERRESTRES | Ordenes Operativas' }]"></Title>

    <v-container fluid>
      <ModalOperaciones
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @print="print"
        @loadList="loadList(service, getFilterParams());"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card>
        <div class="row mb-5 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12" style="background:white; elevation-0">
              <div class="row pt-5">
                <div class="col-md-3 pt-0 ">
                  <v-menu
                    ref="desde_selected"
                    v-model="desde_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde*" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_selected = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0 ">
                  <v-menu
                    ref="hasta_selected"
                    v-model="hasta_selected_open"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta*" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_selected = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="tipo_fecha_selected" autocomplete="off" data-vv-as="tipos_fechas" name="tipos_fechas" :items="tipos_fechas" label="Fecha*" class="pt-0 mt-0" allow></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox
                    multiple
                    v-model="tipo_camiones_selected"
                    autocomplete="off"
                    data-vv-as="tipo_camion"
                    name="tipo_camion"
                    item-text="name"
                    item-value="id"
                    :items="tipos_camiones"
                    label="Tipo Camion"
                    class="pt-0 mt-0"
                    allow
                  ></v-combobox>
                </div>
                
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="factura_selected" autocomplete="off" data-vv-as="factura" name="factura" label="Factura" class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="proformas_numero_selected" autocomplete="off" data-vv-as="proformas_numero" name="proformas_numero" label="Proformas Nº" class="pt-0 mt-0"></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field
                    v-model="referencia_cliente_selected"
                    autocomplete="off"
                    data-vv-as="referencia_cliente"
                    name="referencia_cliente"
                    label="Referencia Cliente"
                    class="pt-0 mt-0"
                  ></v-text-field>
                </div>
                <div class="col-md-3 pt-0">
                  <v-text-field v-model="factura_agente_selected" autocomplete="off" data-vv-as="factura_agente" name="factura_agente" label="Factura Agente" class="pt-0 mt-0"></v-text-field>
                </div>

                <div class="col-md-3 pt-0">
                  <v-checkbox
                    v-model="alerta_fecha_selected"
                    label="Solo Alertas de Fecha"
                    class="pt-0 mt-0"
                  />                  
                </div>

                <div class="col-md-9 pt-0" style="display: flex;justify-content: end;">
                  <!--<v-btn color="error" class="mr-2" @click="export_filter">Exportar</v-btn>-->
                  <v-btn color="info" class="" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <div v-if="selected.length != 0" class="col-md-12" style="background: #f4f1f1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="green" class="cursor mb-1 mt-1" @click="openModalFechaLlegadaETA">edit</v-icon>
            </template>
            <span>Editar Fecha Llegada ETA</span>
          </v-tooltip>
        </div>
        <v-data-table 
          :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..." hide-default-footer disable-pagination
          show-select
          :single-select="false"
          v-model="selected"
        >
          <template v-slot:item="{ item, isSelected, select }">
            <tr :style="getRowStyle(item)">  
              <td>
                <v-checkbox :input-value="isSelected" style="margin: 0px; padding: 0px" hide-details @change="select($event)" :disabled="item.closed" />
              </td>
              <td>{{ item.operacion }}</td>
              <td>{{ showName(item.consignee) }}</td>
              <td>{{ item.crt }}</td>
              <td>{{ item.fecha_salida_etd }}</td>
              <td>{{ item.fecha_llegada_eta }}</td>
              <td>{{ item.fecha_llegada_ata }}</td>
              <td>{{ showName(item.puerto_salida) }}</td>
              <td>{{ showName(item.ultimo_buque) }}</td>
              <td>{{ showName(item.puerto_llegada) }}</td>

              <td class="justify-content" style="min-width:230px">
                <!--<v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="#6e6e6e" class="mr-2" @click="print(item, 'print')">
                      print
                    </v-icon>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>-->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access && !item.closed" v-on="on" small color="red" class="mr-2" @click="closeOperacionDialog(item)">
                      close
                    </v-icon>
                  </template>
                  <span>Cerrar Operacion</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="orange" class="mr-2" @click="openHistoryEstados(item)">timer</v-icon>
                  </template>
                  <span>Ver Historial Estados</span>
                </v-tooltip>
                
                <!--
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="grey" class="mr-2" @click="copy(item)">
                      content_copy
                    </v-icon>
                  </template>
                  <span>Copiar</span>
                </v-tooltip>
                -->

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(item)">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(item)">
                      remove_red_eye
                    </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(item)">
                      delete
                    </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
      <DialogLoading :dialog="dialog_print" text="Imprimiendo..." />
      <DialogConfirm :dialog="dialog_close_op" @updateDialog="resetCloseOperacionDialog" @action="closeOperacion" title="Cerrar Orden" :text="close_op_text" />

      <HistoryModal ref="historyStatesModal" />

      <ModalFechaLlegadaETA
        :service="service"
        :dialog="modal_fecha_llegada_eta"
        :items="selected"
        @updateDialog="closeModalFechaLlegadaETA"
        @loadList="filter"
      />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/";
import { generalService } from "@/libs/ws/generalService";
import { ordersGeneralService } from "@/libs/ws/ordersGeneralService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import DialogLoading from "@/components/DialogLoading.vue";
import DialogConfirm from "@/components/DialogConfirm.vue";
import ModalFechaLlegadaETA from "@/components/ModalFechaLlegadaETA.vue";
import ModalOperaciones from "./ModalOperaciones.vue";
import HistoryModal from "./HistoryModal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import axios from "axios";

export default {
  components: { Title, HistoryModal, ModalOperaciones, DialogDelete, DialogLoading, DialogConfirm, ModalFechaLlegadaETA },
  mixins: [GenericMixin, RolMixin],
  RolMixin,
  data() {
    return {
      selected: [],
      dialog_close_op: false,
      modal_fecha_llegada_eta: false,
      close_op_text: "",   

      parent: this,
      service: ordersGeneralService,
      page_title: "Ordenes Terrestres",
      modal_title: "Orden Terrestre",
      mainItem: {
        id: "",
        operacion: null,
        shipper: null,
        consignee: null,
        facturas: [],        
        packing_lists: [],
        referencia_cliente: null,
        cantidad_camiones: null,
        camiones:[],
        crt: null,
        mic: null,  
        fecha_recoleccion: null,
        fecha_recoleccion_confirmada: null,
        fecha_salida_etd: null,
        fecha_salida_atd: null,
        fecha_llegada_eta: null,
        fecha_llegada_ata: null,
        ultimo_estado: null,      
        comentarios: null,
        lugar_salida: null,
        lugar_llegada: null,
        //ultimo_camion: null,
        facturas_agentes: [],
        
      },
      defaultItem: null,
      headers: [
        { text: "Nº Operacion", align: "left", sortable: true, value: "operacion" },
        { text: "Consignee", align: "left", sortable: true, value: "consignee.name" },
        { text: "CRT", align: "left", sortable: true, value: "crt" },      
        { text: "Fecha Salida ETD", align: "left", sortable: true, value: "fecha_salida_etd" },
        { text: "Fecha Llegada ETA", align: "left", sortable: true, value: "fecha_llegada_eta" },
        { text: "Fecha Llegada ATA", align: "left", sortable: true, value: "fecha_llegada_ata" },
        { text: "Lugar de salida", align: "left", sortable: true, value: "lugar_salida.name" },
        { text: "Camion actual", align: "left", sortable: true, value: "camion.name" },
        { text: "Lugar de llegada", align: "left", sortable: true, value: "lugar_llegada.name" },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      //Dialogs
      dialog_delete: false,
      dialog_print: false,
      //Combos
      tipos_camiones: [],
      shippers: [],
      consignees: [],
      //Filters
      tipos_fechas: ["FECHA CREACION","FECHA SALIDA ( ETD )", "FECHA SALIDA ( ATD )", "FECHA LLEGADA ( ETA )", "FECHA LLEGADA ( ATA )"],
      tipo_fecha_selected: "FECHA CREACION",
      factura_selected: null,
      factura_agente_selected: null,
      referencia_cliente_selected: null,
      tipo_camiones_selected: null,
      id_contenedor_selected: null,
      house_bl_selected: null,
      master_bl_selected: null,
      proformas_numero_selected: null,
      desde_selected_open: false,
      hasta_selected_open: false,
      alerta_fecha_selected: null,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
    };
  },
  mounted() {
    this.service.setSection(Constant.SECTION_ORDERS_TERRESTRES_OP);
    this.loadComboData();
    this.defaultItem = Object.assign({}, this.mainItem);
    this.loadList(this.service, this.getFilterParams());
    this.tipo_fecha_selected = this.tipos_fechas[0];
  },
  methods: {
    showName(element) {
      return element != null ? element.name : "-";
    },
    openHistoryEstados(order) {
      this.$refs.historyStatesModal.open(
        "Estados",
        [
          { text: "Fecha", align: "left", sortable: true, value: "fecha_modificacion" },
          { text: "Estado", value: "estado.name" },
        ],
        order.historial_estados,
        "fecha_modificacion",
        "estado"
      );
    },
    openHistoryBuques(order) {
      this.$refs.historyStatesModal.open(
        "Buques",
        [
          { text: "Fecha", align: "left", sortable: true, value: "fecha_modificacion" },
          { text: "Buque", value: "buque.name" },
        ],
        order.historial_buques,
        "fecha_modificacion",
        "buque"
      );
    },
    getFilterParams() {
      const param = {
        desde: this.desde_selected,
        hasta: this.hasta_selected,
        tipo_fecha: this.tipo_fecha_selected,

        house_bl: this.house_bl_selected,
        master_bl: this.master_bl_selected,
        proformas_numero:  this.proformas_numero_selected,
        factura: this.factura_selected,
        referencia_cliente: this.referencia_cliente_selected,
        factura_agente: this.factura_agente_selected,

        id_contenedor: this.id_contenedor_selected,
        tipo_contenedores: this.tipo_camiones_selected,

        alerta_fecha: (this.alerta_fecha_selected)?this.alerta_fecha_selected:null,
      };
      return param;
    },
    filter() {
      /*
      if(
        this.desde_selected == null ||
        this.hasta_selected == null ||
        this.tipo_fecha_selected == null
      ){
        this.$toast.error("Debe seleccionar una fecha para filtrar.","Error");
        return;
      }
      */
      this.loadList(this.service, this.getFilterParams());
    },
    loadComboData() {
      generalService.filter({}, "shippers").then((response) => {
        this.shippers = response.result;
      });
      generalService.filter({}, "consignees").then((response) => {
        this.consignees = response.result;
      });
      generalService.filter({}, "tipos_camiones").then((response) => {
        this.tipos_camiones = response.result;
      });
    },
    deleteItemConfirm() {
      this.delete(this.service,this.getFilterParams());
      this.dialog_delete = false;
      this.loadList(this.service, this.getFilterParams());
    },
    updateDialog(value, next_flag = false) {
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
      if (!value) {
        this.closeModal(next_flag);
      } else {
        this.dialog = value;
      }
    },
    closeModal(next_flag) {
      if (!next_flag) {
        this.dialog = false;
        this.close();
        return;
      }

      const mainItem_aux = this.mainItem;

      this.mainItem = Object.assign({}, this.defaultItem);

      this.mainItem.shipper = mainItem_aux.shipper;
      this.mainItem.consignee = mainItem_aux.consignee;
      this.mainItem.inssuing_carrier = mainItem_aux.inssuing_carrier;
      this.mainItem.departure_airport = mainItem_aux.departure_airport;
      this.mainItem.arrival_airport = mainItem_aux.arrival_airport;
      this.mainItem.carrier = mainItem_aux.carrier;
      this.mainItem.currency = mainItem_aux.currency;
      this.mainItem.transshipment_airport = mainItem_aux.transshipment_airport;

      this.dialog = false;
      this.editedIndex = -1;
      this.viewdIndex = -1;
      this.errors.clear();
    },
    export_filter() {
      this.service.export_filter(this.getFilterParams()).then((response) => {
        try {
          //Transformo a string la respuesta para poder enviar mensajes de error.
          let result = JSON.parse(this.arrayBufferToString(response));
          if (!result.status) {
            this.$toast.error(result.msg, "Error");
          }
        } catch (e) {
          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          //link.setAttribute('download', "export")
          link.download = "reporte.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          //link.download = code+'.pdf'
          link.click();
        }
      });
    },
    copy(orden) {
      this.errors.clear();

      this.mainItem.shipper = orden.shipper;
      this.mainItem.consignee = orden.consignee;
      this.mainItem.inssuing_carrier = orden.inssuing_carrier;
      this.mainItem.departure_airport = orden.departure_airport;
      this.mainItem.arrival_airport = orden.arrival_airport;
      this.mainItem.carrier = orden.carrier;
      this.mainItem.currency = orden.currency;
      this.mainItem.transshipment_airport = orden.transshipment_airport;

      this.dialog = true;
    },
    print(orden, type) {
      this.dialog_print = true;
      this.service.print(orden.id, type).then((response) => {
        try {
          //Transformo a string la respuesta para poder enviar mensajes de error.
          let result = JSON.parse(this.arrayBufferToString(response));
          if (!result.status) {
            this.$toast.error(result.msg, "Error");
          }
          this.dialog_print = false;
        } catch (e) {
          this.dialog_print = false;
          let blob = new Blob([response], {
            type: "application/pdf",
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = orden.guia_madre + ".pdf";
          link.target = "_blank";
          link.click();
        }
      });
    },
    closeOperacionDialog(item) {
      this.mainItem = item;
      this.close_op_text = "¿Está seguro que desea cerrar la operación " + item.operacion + "?";
      this.dialog_close_op = true;
    },
    resetCloseOperacionDialog() {
      this.dialog_close_op = false;
      this.mainItem = JSON.parse(JSON.stringify(this.defaultItem));
    },
    closeOperacion(){
      this.loading = true;
      return this.service
        .closeOperacion(this.mainItem.id)
        .then((response) => {
          if (response.status == true) {
            this.$toast.success("La orden " + this.mainItem.operacion + " se cerró correctamente.", "OK");
            this.filter();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((response) => {
          this.$toast.error(response.msg, "Error");
        })
        .finally(() => {
          this.resetCloseOperacionDialog();
          this.loading = false;
        });
    },  
    openModalFechaLlegadaETA() {
      if (this.selected.length == 0) {
        this.$toast.error("Debe seleccionar al menos una orden.", "Error");
        return;
      }
      this.modal_fecha_llegada_eta = true;
    },
    closeModalFechaLlegadaETA() {
      this.modal_fecha_llegada_eta = false;
    },
    getRowStyle(item) {
      let style = "";
      if (item.alerta_fecha != null && item.alerta_fecha) {
        style += "background-color: #ffa571;";
      }
      
      if(item.closed){
        style += "background-color: #cdcdcd;";
      }     

      return style;   
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
